const state = () => ({
  strikes: {},
});

const getters = {
  strikes: state => state.strikes,
};

const mutations = {
  addStrike: (state, answerId) => {
    state.strikes[answerId] = true;
  },
  removeStrike: (state, answerId) => {
    state.strikes[answerId] = false;
  },
};

const actions = {
  addStrike: ({ commit }, answerId) => {
    commit('addStrike', answerId);
  },
  removeStrike: ({ commit }, answerId) => {
    commit('removeStrike', answerId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
